/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateReminderMutationRequest,
  UpdateReminderMutationResponse,
  UpdateReminderPathParams,
  UpdateReminder400,
  UpdateReminder404,
  UpdateReminder500,
} from '../types/UpdateReminder'

function getUpdateReminderUrl({ id }: { id: UpdateReminderPathParams['id'] }) {
  const res = {
    method: 'PUT',
    url: `/api/v1/reminders/reminders/${id}/` as const,
  }
  return res
}

/**
 * @description Update an existing reminder (full update).
 * Delegates to UpdateReminderUsecase for business logic.
 * @summary Full update of an existing reminder
 * {@link /api/v1/reminders/reminders/:id/}
 */
export async function updateReminder(
  { id }: { id: UpdateReminderPathParams['id'] },
  data: UpdateReminderMutationRequest,
  config: Partial<RequestConfig<UpdateReminderMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateReminderMutationResponse,
    ResponseErrorConfig<
      UpdateReminder400 | UpdateReminder404 | UpdateReminder500
    >,
    UpdateReminderMutationRequest
  >({
    method: 'PUT',
    url: getUpdateReminderUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
